<template>
  <div class="hvh-table-container position-relative">
    <v-card elevation="3" class="hvh-card--rounded">
      <div class="hvh-flex column align-center p-5">
        <h2 class="hvh-h7 mb-3">You can download your exported results here:</h2>
        <v-btn flat class="hvh-btn hvh-btn--primary" @click="download">Download</v-btn>
      </div>
    </v-card>
    <loader v-if="loading" />
  </div>
</template>
<script>
import axios from '../../../axios';
import { saveAs } from 'file-saver';
import { errorDebug, isString, sanitize } from '../../../libraries/common';
export default {
  title: 'Download Results',
  props: ['runId'],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    download() {
      this.loading = true;
      axios
        .get(`/Analytics/CohortAnalyticRun/${this.runId}/PresignedUrl`)
        .then(({ data }) => axios.get(data)
        .then(({ data }) => {
          var unzippedResult = pako.inflate(atob(data), { to: 'string' }); // eslint-disable-line
          var result = JSON.parse(unzippedResult)
            .map(arr => arr.map(val => isString(val) && val.indexOf(',') > -1 ? `"${val}"` : val))
            .join('\n');
          var blob = new Blob([result], { type: 'text/plain;charset=utf-8' });
          saveAs(blob, sanitize(`Export Results ${this.browserDateTime(new Date()).replaceAll('/', '-').replaceAll(':', '-')}.csv`));
        })
        .catch(errorDebug)
        .then(() => this.loading = false));
    },
  },
};
</script>